module.exports = __webpack_public_path__ + "static/img/tw.c81d563.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/fiveG/function/tw.png
// module id = lCtT
// module chunks = 1